<template>
  <div>
    <ml-header
      :dark="true"
      :title="`${value} / ${tag}`"
      background-color="#fff"
    />
    <div class="video-page-container">
      <ml-loading class="loading" v-if="loading" />
      <div class="empty-video" v-else-if="empty">
        <img src="../../assets/personal/un_upload_video@2x.png" alt="" />
        <p>没有找到相关视频</p>
      </div>
      <VerticalLayoutVideo v-else :videos="videos" />
    </div>
  </div>
</template>

<script>
import VerticalLayoutVideo from "@/views/video/components/VerticalLayoutVideo";
import { searchVideo } from "@/api/video";

export default {
  name: "VideoSearchResult",
  components: { VerticalLayoutVideo },
  data() {
    return {
      value: this.$route.params.value,
      tag: this.$route.query.tag,
      videos: [],
      loading: false,
      empty: false
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.empty = false;
      const responseData = await searchVideo(this.value, this.tag);
      this.videos = responseData.content;
      if (responseData.content.length === 0) {
        this.empty = true;
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.video-page-container {
  padding: 64px 15px 0 15px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .loading {
    margin-top: -64px;
  }
  .empty-video {
    margin-top: -150px;
    img {
      width: 76px;
      height: 76px;
    }
    p {
      margin-top: 12px;
      line-height: 22px;
    }
  }
}
</style>
